const baseUrl = process.env.API_BASE_URL;

function getLocalOffset() {
  var date = new Date();
  return date.getTimezoneOffset();
}

export const config = {
  store: null,
  authHeader: () => config.store.getState().auth.authToken,
  unauthorizedGetNotifier: () => {},
  unauthorizedPostNotifier: () => {},
  revokeAccessNotifier: () => {}
}

export function fake(result) {
  return new Promise(resolve => {
    setTimeout(() => resolve(result), 400);
  });
}

export function get(url, queryParams) {
  if (queryParams) {
    const queryString = Object.keys(queryParams || {})
                              .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
                              .join('&');
    url += `?${queryString}`;
  }
  return apiCall('GET', url);
}

export function post(url, data) {
  return apiCall('POST', url, data);
}

export function put(url, data) {
  return apiCall('PUT', url, data);
}

export function httpDelete(url) {
  return apiCall('DELETE', url);
}

export function postFormData(url, data) {

  return fetch(`${baseUrl}${url}`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'SetupAuthorization': config.authHeader(),
      'Timezone-Offset': getLocalOffset()
    },
    body: data
  })
  .then(res => {
    if (res.ok) {
      console.log(res);
      return res.json().catch(() => null);
    }

    throw res;
  })
  .catch(err => {
    return err.json()
      .then(err => {
        throw (err && err.errorCode && err.errorMessage)
          ? err
          : {
            errorCode: 'api-client',
            errorMessage: 'An unknown error has occurred.'
          }
      });
  });
}

function apiCall(method, url, data) {
  return fetch(`${baseUrl}${url}`, {
    method,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'SetupAuthorization': config.authHeader(),
      'Timezone-Offset': getLocalOffset()
    },
    body: JSON.stringify(data)
  })
  .then(res => {
    if (res.ok) {
      window.res = res
      return res.json().catch(() => { });
    }

    throw res;
  })
  .catch(res => {
    return res.json()
      .then(err => {
        if (err && err.errorCode === 'unauthenticated') {
          method === 'GET'
            ? config.unauthorizedGetNotifier()
            : config.unauthorizedPostNotifier();
        }
        else if(err && err.errorCode === 'access-revoked-error') {
          config.revokeAccessNotifier();
        }

        throw (err && err.errorCode && err.errorMessage)
          ? err
          : {
            errorCode: 'api-client',
            errorMessage: 'An unknown error has occurred.'
          }
      });
  });
}



// WEBPACK FOOTER //
// src/api/rest-api-calls.js